module.exports = __webpack_public_path__ + "img/logo.afecefd7.svg";